import { Component, Input, OnInit, TemplateRef } from '@angular/core';

interface LogoProps {
  logo: TemplateRef<any>;
  position?: 'top' | 'bottom';
}

@Component({
  selector: 'ng-mf-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {

  @Input() avatarStyle: 'solid' | 'ghost' = 'solid';
  @Input() color: 'red' | 'orange' | 'green' | 'purple' | 'sky-blue' | 'default' = 'default';
  @Input() floatingIcon: LogoProps;
  @Input() showLogo = false;
  @Input() avatarType;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
  @Input() rounded = false;
  @Input() disabled = false;

  constructor() { }

  containsImgTag(children: any): boolean {
    let hasImgTag = false;
    if (typeof this.avatarType === 'string') {
      hasImgTag = false;
    } else {
      if (this.avatarType && this.avatarType instanceof HTMLElement) {
        // Check if the template contains an image tag
        const imageTag = this.avatarType.querySelector('img');
        hasImgTag = !!imageTag;
      }
    }

    return hasImgTag;
  }

  isString(node: any): boolean {
    return typeof node === 'string';
  }

  isObject(obj: any): boolean {
    return obj instanceof Object && 'logo' in obj;
  }

  get avatarContainerClass(): string {
    return `kamona-avatar avatar-${this.size} ${this.avatarStyle === 'ghost' ? 'avatar-ghost' : 'avatar-solid'}
      ${!this.containsImgTag(this.avatarType) && this.avatarStyle === 'ghost' && this.disabled ? 'disabled' : ''}
      ${this.isString(this.avatarType) ? 'letters' : ''}`;
  }

  get avatarVariantContainerClass(): string {
    return `${this.rounded ? 'kamona-avatar-image-rounded' : 'kamona-avatar-image'} ${this.color}`;
  }

  get logoContainerClass(): string {
    if (this.isObject(this.floatingIcon)) {
      const floatingIconProps = this.floatingIcon as LogoProps; // Type assertion
      return `floating-logo ${this.disabled ? this.color : 'disabled'} ${floatingIconProps.position || 'top'}`;
    } else {
      return `floating-logo ${this.disabled ? this.color : 'disabled'} top`; // Default to 'top' if not a LogoProps
    }
  }

}
